import { useTelephoneContext } from "@/modules/lead-page/new/hooks/telephone-context.hook";
import useTelephoneConfig from "@/modules/lead-page/new/hooks/telephone-config.hook";
import { Box, Typography, useTheme, IconButton } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import CallIcon from "@/assets/icons/lead-page/call-icon";
import WhatsappIcon from "@/assets/icons/lead-page/whatsapp-icon";
import { handleContactWhatsapp } from "@/modules/common/utils";
import useLeadContactMethods from "@/modules/lead-page/hooks/lead-info/lead-contact-methods.hook.ts";
import CallPopoverButton from "@/modules/common/components/call-popover-button";

const PrimaryNumber = () => {
  const { telephone } = useTelephoneContext();
  const { primaryTelephone } = useTelephoneConfig();
  const { isLoading } = useLeadContactMethods();

  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: theme.nawy.spacing.xxs,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            gap: "4px",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              ...theme.nawy.typography.english.variants.body.sm.regular,
              color: theme.nawy.colors.semantic.text.secondary,
            }}
          >
            Primary phone
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              pr: "16px",
            }}
          >
            <Typography
              sx={{
                ...theme.nawy.typography.english.variants.body.md.regular,
                color: primaryTelephone
                  ? theme.nawy.colors.semantic.text.primary
                  : theme.nawy.colors.semantic.text.tertiary,
              }}
            >
              {primaryTelephone ? primaryTelephone.telephone : "Not set"}
            </Typography>

            {primaryTelephone && (
              <Box sx={{ display: "flex", gap: "6px" }}>
                <CallPopoverButton phoneNumber={primaryTelephone.telephone}>
                  <IconButton
                    sx={{
                      width: 36,
                      height: 36,
                      opacity: isLoading ? 0.6 : 1,
                    }}
                    disabled={isLoading}
                  >
                    <CallIcon fill={theme.nawy.colors.semantic.text.accent} />
                  </IconButton>
                </CallPopoverButton>

                <IconButton
                  sx={{ width: 36, height: 36 }}
                  onClick={() =>
                    handleContactWhatsapp(primaryTelephone.telephone)
                  }
                >
                  <WhatsappIcon />
                </IconButton>
              </Box>
            )}
          </Box>
        </Box>

        <Box
          onClick={() => {
            telephone.setEditTelephoneModalOpen(false);
            telephone.setTelephone("");
          }}
          sx={{
            alignSelf: "flex-start",
            height: "100%",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <ClearIcon
            sx={{
              height: "20px",
              width: "20px",
              color: "gray",
              ":hover": { color: "black" },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PrimaryNumber;
